export enum EmailValuationType {
  VALID = 'valid',
  IN_VALID = 'invalid',
  REGISTERED = 'registered',
}
